/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
/**
 * Represents a template that defines the content of the whole Step.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoStepperStepTemplate` directive inside the `<kendo-stepper>` tag.
 */
var StepperStepTemplateDirective = /** @class */ (function () {
    function StepperStepTemplateDirective(templateRef) {
        this.templateRef = templateRef;
    }
    StepperStepTemplateDirective = tslib_1.__decorate([
        core_1.Directive({
            selector: '[kendoStepperStepTemplate]'
        }),
        tslib_1.__param(0, core_1.Optional()),
        tslib_1.__metadata("design:paramtypes", [core_1.TemplateRef])
    ], StepperStepTemplateDirective);
    return StepperStepTemplateDirective;
}());
exports.StepperStepTemplateDirective = StepperStepTemplateDirective;
